import React, { useContext } from "react";
import { Redirect } from "react-router";
import { StoreContext } from "../context/StoreContext";

const Error = ({ location }) => {
  const { state } = useContext(StoreContext);
  if (state.answers === undefined) {
    return <Redirect to="/" />;
  }
  return (
    <React.Fragment>
      <section className="jumbotron text-center">
        <div className="container">
          <h1 className="jumbotron-heading">404</h1>
        </div>
      </section>
      <section className="request">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3>Sorry, the page you requested cannot be found</h3>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Error;
